<section class="content-header" style="padding: 0.5% !important;">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-6">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/admin/']"
              ><i class="fas fa-home"></i> &nbsp;Trang chủ</a
            >
          </li>
          <li class="breadcrumb-item active">Danh sách ra</li>
        </ol>
      </div>
      <div class="col-md-6">
        <button
          class="btn btn-primary btn-sm"
          (click)="getList()"
          style="float: right; margin-right: 10px;"
        >
          <i class="fas fa-search"></i> Tìm kiếm
        </button>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body" *ngIf="isDisplay">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-2">
          <label>Mã sinh viên</label>
          <input
            type="text"
            class="form-control cus-fs"
            [(ngModel)]="FillMaSV"
            (keyup.enter)="getList()"
            placeholder="Nhập mã sinh viên ..."
          />
        </div>
        <div class="col-md-2">
          <label>Tên sinh viên</label>
          <input
            type="text"
            class="form-control cus-fs"
            [(ngModel)]="FillHoTen"
            (keyup.enter)="getList()"
            placeholder="Nhập tên sinh viên..."
          />
        </div>
        <div class="col-md-2">
          <label>Trạng thái thanh toán</label>
          <select
            class="form-control cus-fs"
            [(ngModel)]="FillLoaiDongTien"
            (change)="getList()"
          >
            <option value=""> Chọn</option>
            <option value="1"> Đã đóng tiền </option>
            <option value="0"> Chưa đóng tiền</option>
          </select>
        </div>
        <!-- <div class="col-md-2">
          <label>Quốc tịch</label>
          <input type="text" class="form-control cus-fs" [(ngModel)]="FillQuocTich" (keyup)="filterTable()"
            placeholder="Nhập quốc tịch..." />
        </div> -->
        <!-- <div class="col-md-3">
          <label>Số phòng</label>
          <input type="text" class="form-control cus-fs" [(ngModel)]="FillPhong" (keyup)="filterTable()"
            placeholder="Nhập số phòng ..." />
        </div>  -->
        <div class="col-md-2">
          <label>Thời gian vào</label>
          <span>
            <input
              type="date"
              [(ngModel)]="FillThoiGianVao"
              (change)="getList()"
              class="form-control cus-fs"
            />
          </span>
        </div>
        <div class="col-md-2">
          <label>Thời gian ra</label>
          <span>
            <input
              type="date"
              [(ngModel)]="FillThoiGianRa"
              (change)="getList()"
              class="form-control cus-fs"
            />
          </span>
        </div>
        <!-- <div class="col-md-2">
          <label>Ngày hết hạn Visa</label>
          <input type="date" class="form-control cus-fs" [(ngModel)]="FillThoiGianVisa" (change)="filterTable()" />
        </div> -->
        <div class="col-md-2">
          <label>Lý do ra</label>
          <input
            type="text"
            class="form-control cus-fs"
            [(ngModel)]="FillLy_do"
            (keyup.enter)="getList()"
            placeholder="Nhập lý do..."
          />
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-2">
          <label>Cơ sở</label>
          <select
            class="form-control cus-fs"
            [(ngModel)]="FillCoSo"
            (change)="changeCampus($event.target.value)"
          >
            <option value="">Chọn cơ sở</option>
            <option *ngFor="let i of dataCampus" value="{{ i.ID }}">{{
              i.name
            }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Tòa nhà</label>
          <select
            class="form-control cus-fs"
            [(ngModel)]="FillToaNha"
            (change)="changeRoom($event.target.value)"
          >
            <option value="">Chọn tòa nhà</option>
            <option *ngFor="let i of dataBuilding" value="{{ i.ID_ToaNha }}">{{
              i.Ten_ToaNha
            }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label>Tầng</label>
          <input
            class="form-control cus-fs"
            placeholder="Tìm kiếm tầng..."
            [(ngModel)]="FillTang"
            (keyup.enter)="getList()"
          />
        </div>
        <div class="col-md-2">
          <label>Tên phòng</label>
          <select
            class="form-control cus-fs"
            [(ngModel)]="FillPhong"
            (change)="getList()"
          >
            <option value="">Chọn phòng</option>
            <option
              *ngFor="let item of dataRoom"
              value="{{ item.Ten_phong }}"
              >{{ item.Ten_phong }}</option
            >
          </select>
        </div>
        <div class="col-md-2">
          <label>Loại phòng</label>
          <div class="input-group">
            <select
              class="form-control"
              [(ngModel)]="FillLoaiPhong"
              (change)="getList()"
            >
              <option value="">Tất cả</option>
              <option *ngFor="let p of dataTypeRoom" value="{{ p.ID }}"
                >{{ p.Ten_loai_phong }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <label>Phòng Nam/Nữ</label>
          <select
            class="form-control cus-fs"
            [(ngModel)]="FillPhongNamNu"
            (change)="getList()"
          >
            <option value="" selected>Tất cả</option>
            <option value="0">Nam</option>
            <option value="1">Nữ</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body">
  <div class="card">
    <div class="card-body">
      <div class="tab-content">
        <div class="active tab-pane">
          <div class="row">
            <div class="col-md-6">
              Hiển thị
              <select (change)="handlePageSizeChange($event)">
                <option *ngFor="let size of pageSizes" [ngValue]="size">
                  {{ size }}
                </option>
              </select>
              kết quả
            </div>
            <div class="col-md-6">
              <button
                title="Ẩn/hiện bộ lọc"
                style="float: right; margin: 0 0 5px 5px;"
                (click)="buttonFilter()"
              >
                <i class="fas fa-filter"></i>
              </button>
              <button
                title="Tải lại"
                style="float: right; margin-bottom: 5px;"
                (click)="refesh()"
              >
                <i class="fas fa-redo-alt"></i>
              </button>
            </div>
          </div>
          <div
            class="table-responsive"
            style="max-height: 60vh; margin-bottom: 15px;"
          >
            <input
              type="text"
              [(ngModel)]="searchString"
              placeholder="Tìm kiếm nhanh"
              style="float: right; margin-bottom: 10px;"
            />
            <table class="table table-bordered">
              <thead>
                <th>Mã sinh viên</th>
                <th>Họ và tên</th>
                <th>Khoá - Lớp</th>
                <th>Toà nhà - Phòng</th>
                <th>Ngày vào</th>
                <th>Ngày ra</th>
                <th>Số tiền phải đóng</th>
                <th>Số tiền đã đóng</th>
                <th>Số tiền thừa/thiếu</th>
                <th>Số tiền hoàn trả</th>
                <th>Số tháng ở</th>
                <th>Lý do</th>
              </thead>
              <tbody>
                <tr *ngFor="let p of dataTable | filter: searchString">
                  <td>{{ p.Ma_sv }}</td>
                  <td>{{ p.Ho_ten }}</td>
                  <td>{{ p.Khoa_Lop }}</td>
                  <td>{{ p.ToaNha_Phong }}</td>
                  <td>
                    {{
                      p.Ngay_bat_dau == null
                        ? ''
                        : (p.Ngay_bat_dau | date: 'dd/MM/yyyy')
                    }}
                  </td>
                  <td>
                    {{
                      p.Ngay_ket_thuc == null
                        ? ''
                        : (p.Ngay_ket_thuc | date: 'dd/MM/yyyy')
                    }}
                  </td>
                  <td>{{ p.So_tien_phai_dong | number }}</td>
                  <td>{{ p.So_tien_da_nop | number }}</td>
                  <td>{{ p.So_tien_con_no | number }}</td>
                  <td>{{ p.So_tien_hoan_tra }}</td>
                  <td>{{ p.So_thang_o }}</td>
                  <td>{{ p.Ly_do }}</td>
                </tr>

                <tr *ngIf="dataTable.length == 0">
                  <td colspan="13" class="text-center">Không có kết quả</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-md-6">
              <p style="float: left; font-weight: bold;">
                Tổng số {{ totalItem | number }} kết quả, đã lọc được
                {{ totalItemFilter | number }} kết quả
              </p>
            </div>
            <div class="col-md-6">
              <nav aria-label="Page navigation example" style="float: right;">
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="page == 1">
                    <a class="page-link" (click)="changPage(1)">Đầu</a>
                  </li>
                  <li class="page-item" [class.disabled]="page == 1">
                    <a class="page-link" (click)="changPage('pre')">Trước</a>
                  </li>
                  <ng-container *ngIf="page > 4">
                    <li class="page-item"><a class="page-link">...</a></li>
                  </ng-container>
                  <ng-container *ngFor="let element of arrNumberPage_chil">
                    <li class="page-item" [class.active]="page == element">
                      <a class="page-link" (click)="changPage(element)">{{
                        element
                      }}</a>
                    </li>
                  </ng-container>
                  <ng-container *ngIf="page < numberPage - 4">
                    <li class="page-item"><a class="page-link">...</a></li>
                  </ng-container>
                  <li class="page-item" [class.disabled]="page == numberPage">
                    <a class="page-link" (click)="changPage('next')">Sau</a>
                  </li>
                  <li class="page-item" [class.disabled]="page == numberPage">
                    <a class="page-link" (click)="changPage(numberPage)"
                      >Cuối</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <!-- <div class="active tab-pane" id="TeachInfo">
          <div class="row">
            <div
              class="table-responsive dataTables_wrapper container-fluid dt-bootstrap4"
            >
              <table
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table-bordered dataTables_wrapper no-footer"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of dataTable">
                    <td>{{ p.ID_dang_ky }}</td>
                    <td>{{ p.Ma_sv }}</td>
                    <td>{{ p.Ho_ten }}</td>
                    <td>
                      <div *ngIf="p.Truong_Phong">
                        Trưởng phòng
                      </div>
                      <div *ngIf="!p.Truong_Phong">
                        Thành viên
                      </div>
                    </td>
                    <td>{{ p.Quoc_Tich }}</td>
                    <td>{{ p.Ngay_Het_Han_Visa | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ p.Khoa_Lop }}</td>
                    <td>{{ p.ToaNha_Phong }}</td>
                    <td>{{ p.Ngay_bat_dau | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ p.Ngay_ket_thuc | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ p.ID_doi_tuong }}</td>
                    <td>{{ p.Trang_thai_o }}</td>
                    <td>{{ p.So_tien_phai_dong | number }}</td>
                    <td>{{ p.So_tien_da_nop | number }}</td>
                    <td>{{ p.ID_Toa_Nha }}</td>
                    <td>{{ p.ID_Co_So }}</td>
                    <td>{{ p.ID_Tang }}</td>
                    <td>{{ p.ID_loai_phong }}</td>
                    <td>{{ p.Phong_nam_nu }}</td>
                    <td>{{ p.So_tien_con_no | number }}</td>
                    <td>{{ p.So_tien_hoan_tra }}</td>
                    <td>{{ p.So_thang_o }}</td>
                    <td>{{ p.Ly_do }}</td>
                    <td style="white-space: nowrap;">
                      <button
                        class="btn btn-sm btn-info"
                        (click)="open(Approve, '', 'approve', p)"
                        style="margin-right: 7px;"
                      >
                        <i
                          class="fas fa-arrow-left"
                          ngbTooltip="Quay lại kí túc xá"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
<ng-template #ThemModal let-modal>
  <div
    class="modal-header m-header text-center"
    style="padding-top: 0px; padding-bottom: 0px;"
  >
    <h5 class="modal-title h-title w-100">{{ titleModal }}</h5>
    <span
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
      style="font-size: 25px;"
      >&times;</span
    >
  </div>
  <div class="modal-body cus-fs">
    <form class="form-horizontal" [formGroup]="Action">
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">Mã SV</label>
          <input
            class="form-control"
            placeholder="Nhập mã sv"
            formControlName="Ma_sv"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Họ tên</label>
          <input
            class="form-control"
            placeholder="Nhập họ tên"
            formControlName="Ho_ten"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Ngày sinh</label>
          <input
            class="form-control"
            placeholder="Nhập ngày sinh"
            formControlName="Ngay_sinh"
            type="date"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Giới tính</label>
          <select class="form-control" formControlName="Gioi_Tinh" disabled>
            <option value="2">Chọn giới tính</option>
            <option value="0">Nam</option>
            <option value="1">Nữ</option>
          </select>
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">Số hộ chiếu</label>
          <input
            class="form-control cus-fs"
            placeholder="Nhập số hộ chiếu"
            type="text"
            formControlName="So_Ho_Chieu"
          />
          <!-- [ngClass]="{
              'is-invalid': submitted && checkvalue.So_Ho_Chieu.errors
            }" /> -->
          <!-- <div *ngIf="submitted && checkvalue.So_Ho_Chieu.errors" class="invalid-feedback">
            <div *ngIf="checkvalue.So_Ho_Chieu.errors.required">
              số hộ chiếu không được bỏ trống!
            </div>
            <div *ngIf="checkvalue.So_Ho_Chieu.errors.maxlength">
              số hộ chiếu tối đa 20 ký tự!
            </div>
          </div> -->
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Ngày hết hạn Visa</label>
          <input
            class="form-control cus-fs"
            placeholder="Nhập ngày hết hạn Visa"
            type="date"
            formControlName="Ngay_Het_Han_Visa"
          />
          <!-- [ngClass]="{
              'is-invalid': submitted && checkvalue.Ngay_Het_Han_Visa.errors
            }" />
          <div *ngIf="submitted && checkvalue.Ngay_Het_Han_Visa.errors" class="invalid-feedback">
            <div *ngIf="checkvalue.Ngay_Het_Han_Visa.errors.required">
              Ngày hết hạn Visa không được bỏ trống!
            </div>
          </div> -->
        </div>
        <div class="col-md-3">
          <label class="col-md-10 require">Ngày vào KTX</label>
          <input
            class="form-control cus-fs"
            required
            type="date"
            formControlName="Ngay_bat_dau"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Ngay_bat_dau.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Ngay_bat_dau.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Ngay_bat_dau.errors.required">
              Ngày vào không được bỏ trống!
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="col-md-10 require">Ngày ra KTX</label>
          <input
            class="form-control cus-fs"
            required
            type="date"
            formControlName="Ngay_ket_thuc"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Ngay_ket_thuc.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Ngay_ket_thuc.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Ngay_ket_thuc.errors.required">
              Ngày vào không được bỏ trống!
            </div>
          </div>
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">CMND</label>
          <input
            class="form-control"
            placeholder="Nhập cmnd"
            formControlName="CMND"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Ngày cấp</label>
          <input
            class="form-control"
            placeholder="Nhập ngày cấp"
            formControlName="Ngay_cap_CMND"
            type="date"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Nơi cấp</label>
          <input
            class="form-control"
            placeholder="Nhập nơi cấp"
            formControlName="Noi_cap_CMND"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Tôn giáo</label>
          <input
            class="form-control"
            placeholder="Nhập tôn giáo"
            formControlName="Ton_giao"
            type="text"
            disabled
          />
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">Điện thoại</label>
          <input
            class="form-control"
            placeholder="Nhập điện thoại"
            formControlName="Dienthoai_canhan"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Email</label>
          <input
            class="form-control"
            placeholder="Nhập email"
            formControlName="Email"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Quốc tịch</label>
          <input
            class="form-control"
            placeholder="Nhập dân tộc"
            formControlName="ID_quoc_tich"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Dân tộc</label>
          <input
            class="form-control"
            placeholder="Nhập dân tộc"
            formControlName="Dan_toc"
            type="text"
            disabled
          />
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">Họ tên cha</label>
          <input
            class="form-control"
            placeholder="Nhập họ tên cha"
            formControlName="Ho_ten_cha"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Năm sinh cha</label>
          <input
            class="form-control"
            placeholder="Nhập năm sinh cha"
            formControlName="Namsinh_cha"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Nghề nghiệp cha</label>
          <input
            class="form-control"
            placeholder="Nhập nghề nghiệp cha"
            formControlName="Hoat_dong_XH_CT_cha"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Số đt cha</label>
          <input
            class="form-control"
            placeholder="Nhập số đt cha"
            formControlName="So_dien_thoai_bo"
            type="text"
            disabled
          />
        </div>
      </div>
      <div class="row mt10">
        <div class="col-md-3">
          <label class="col-md-10">Họ tên mẹ</label>
          <input
            class="form-control"
            placeholder="Nhập họ tên mẹ"
            formControlName="Ho_ten_me"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Năm sinh mẹ</label>
          <input
            class="form-control"
            placeholder="Nhập năm sinh mẹ"
            formControlName="Namsinh_me"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Nghề nghiệp mẹ</label>
          <input
            class="form-control"
            placeholder="Nhập nghề nghiệp mẹ"
            formControlName="Hoat_dong_XH_CT_me"
            type="text"
            disabled
          />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Số đt mẹ</label>
          <input
            class="form-control"
            placeholder="Nhập số đt mẹ"
            formControlName="So_dien_thoai_me"
            type="text"
            disabled
          />
        </div>
      </div>
      <!-- <div class="row mt10">

        <div class="col-md-3">
          <label class="col-md-10">Hệ </label>
          <input class="form-control" placeholder="" type="text" formControlName="he_nhap_hoc" disabled />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Khoa </label>
          <input class="form-control" placeholder="" type="text" formControlName="ID_Khoa" disabled />
        </div>

        <div class="col-md-3">
          <label class="col-md-10">Khóa </label>
          <input class="form-control" placeholder="" type="text" formControlName="Khoa_hoc" disabled />
        </div>
        <div class="col-md-3">
          <label class="col-md-10">Lớp</label>
          <input class="form-control" placeholder="" type="text" formControlName="Lop" disabled />
        </div>
      </div> -->

      <div class="row mt10">
        <div class="col-md-6">
          <label class="col-md-10">Địa chỉ</label>
          <input
            class="form-control"
            placeholder="Nhập địa chỉ"
            formControlName="Dia_chi_tt"
            type="text"
            disabled
          />
        </div>
        <div class="col-md-6 `">
          <label class="col-md-10">Nơi ở hiện nay</label>
          <input
            class="form-control"
            placeholder="Nhập nơi ở hiện nay"
            formControlName="NoiO_hiennay"
            type="text"
            disabled
          />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button
        type="button"
        class="btn btn-md btn-danger"
        (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;"
      >
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>

<ng-template #Approve let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="icon-box">
        <i
          class="fas fa-arrow-circle-right"
          style="
            color: #f15e5e;
            font-size: 46px;
            display: inline-block;
            margin-top: 13px;
          "
        ></i>
      </div>
      <p
        style="
          color: inherit;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-weight: 600;
          margin-top: 3em;
        "
      >
        Bạn có chắc chắn cho sinh viên quay lại kí túc xá
      </p>
      <div class="text-center">
        <button
          type="button"
          class="btn btn-md btn-danger"
          (click)="modal.dismiss('Cross click')"
        >
          Hủy bỏ
        </button>
        <button
          type="button"
          class="btn btn-md btn-success"
          (click)="Aprove()"
          style="margin-left: 1em;"
        >
          Đồng ý
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #RoomLead let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="icon-box" style="border: solid green;">
        <i
          class="fas fa-plus-circle"
          style="
            color: #177a2c;
            font-size: 46px;
            display: inline-block;
            margin-top: 13px;
          "
        ></i>
      </div>
      <p
        style="
          color: inherit;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-weight: 600;
          margin-top: 3em;
        "
      >
        Bạn có chắc chắn cho sinh viên thành trưởng phòng
      </p>
      <div class="text-center">
        <button
          type="button"
          class="btn btn-md btn-success"
          (click)="AproveChange()"
        >
          Đồng ý
        </button>
        <button
          type="button"
          class="btn btn-md btn-danger"
          (click)="modal.dismiss('Cross click')"
          style="margin-left: 1em;"
        >
          Hủy bỏ
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #Confirm let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="icon-box">
        <i
          class="fas fa-print"
          style="
            color: #f15e5e;
            font-size: 46px;
            display: inline-block;
            margin-top: 13px;
          "
        ></i>
      </div>
      <p
        style="
          color: inherit;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-weight: 600;
          margin-top: 3em;
        "
      >
        Bạn có chắc chắn tạo biên lai
      </p>
      <div class="text-center">
        <div>
          <button
            type="button"
            class="btn btn-md btn-success"
            (click)="Print()"
          >
            Đồng ý
          </button>
          <button
            type="button"
            class="btn btn-md btn-danger"
            (click)="modal.dismiss('Cross click')"
            style="margin-left: 1em;"
          >
            Hủy bỏ
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div id="print-section" style="display: none;">
  <app-receipt-room [dt_print]="dt_print"></app-receipt-room>
</div>
